
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Industrialfabrication() {



  const cardData =
  {
    keyword: ' All Types of Industrial Fabrication Work Services',
    heading: 'Anjali Enterprises: All Types of Industrial Fabrication Work Services',
    headingDescription: 'At Anjali Enterprises, we specialize in providing comprehensive industrial fabrication services, offering customized solutions for a wide range of industries. Our expert team is dedicated to delivering high-quality metal and steel fabrication, ensuring that each project meets the unique requirements of our clients in Pune and beyond.',

    "topPlaces": [
        {
          "title": "Industrial Fabrication Services",
          "description": "Our industrial fabrication services encompass the entire process, from design to execution. We provide precision metal work and custom solutions that cater to the specific needs of industries, ensuring long-lasting and efficient results."
        },
        {
          "title": "Custom Industrial Fabrication",
          "description": "We specialize in custom industrial fabrication, offering tailored solutions to suit your business’s operational needs. Whether it's a unique structural component or specialized metal work, our team delivers highly durable and reliable custom designs."
        },
        {
          "title": "Metal Fabrication in Pune",
          "description": "As a trusted name in metal fabrication in Pune, Anjali Enterprises provides premium metal fabrication services for a variety of industrial applications. From heavy-duty metal components to intricate structures, we offer top-tier solutions to meet the demands of different industries."
        },
        {
          "title": "Industrial Steel Fabrication",
          "description": "Our industrial steel fabrication services are designed to meet the structural and functional requirements of your business. We fabricate strong, durable steel components for a wide range of industrial uses, ensuring high performance and long service life."
        },
        {
          "title": "Heavy-Duty Metal Work",
          "description": "We are experts in heavy-duty metal work, providing the necessary strength and durability for industrial projects. From large-scale structures to specialized components, we offer custom metal fabrication that can withstand the rigors of heavy industrial use."
        },
        {
          "title": "Structural Fabrication",
          "description": "Our structural fabrication services ensure that your industrial units are built with strong, durable frameworks. We specialize in creating steel and metal structures that are designed to support heavy loads, ensuring safety and reliability for long-term use."
        },
        {
          "title": "Fabrication of Steel Components",
          "description": "We offer precision fabrication of steel components, tailored to your industrial needs. Whether it's beams, supports, or frames, our fabrication services ensure that every steel component meets the highest standards of quality and performance."
        },
        {
          "title": "Custom Industrial Fabrication Services",
          "description": "At Anjali Enterprises, we understand that each industry has unique needs. Our custom industrial fabrication services are designed to offer personalized solutions, ensuring that every project is crafted according to your specifications and requirements."
        },
        {
          "title": "MS Fabrication Work for Industrial Units",
          "description": "We offer specialized MS (Mild Steel) fabrication work for industrial units, ensuring that your fabrication needs are met with precision. From structural steel frames to customized components, we deliver durable and cost-effective MS solutions for your industrial projects."
        },
        {
          "title": "Precision Metal Fabrication for Industries",
          "description": "Our precision metal fabrication services focus on delivering high-accuracy components and structures. We utilize advanced techniques and machinery to ensure that every piece of metal work is fabricated with utmost precision, making it suitable for various industrial applications."
        },
        {
          "title": "Anjali Enterprises Contact Number",
          "description": "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality industrial fabrication work. We specialize in all types of industrial fabrication services, including MS fabrication, structural fabrication, custom fabrication, and more, offering durable and precise solutions for various industrial needs. Get in touch for expert installation and professional service. Serving Pune with top-notch industrial fabrication work tailored to your specific requirements."
        }
      ],
      "tableData": [
        ["- Industrial Fabrication Services", "- Custom Industrial Fabrication"],
        ["- Metal Fabrication in Pune", "- Industrial Steel Fabrication"],
        ["- Heavy-Duty Metal Work", "- Structural Fabrication"],
        ["- Fabrication of Steel Components", "- Custom Industrial Fabrication Services"],
        ["- MS Fabrication Work for Industrial Units", "- Precision Metal Fabrication for Industries"],
        ["- Anjali Enterprises Contact Number", ""]
      ],


    "whychoose": [
  {
    "WhyChooseheading": "Comprehensive Industrial Fabrication Services",
    "WhyChoosedescription": "At Anjali Enterprises, we offer a wide range of industrial fabrication services to meet the diverse needs of various industries. Whether you require custom metal structures, specialized machinery, or intricate components, we have the expertise, equipment, and resources to handle all types of industrial fabrication projects. Our services cater to manufacturing plants, warehouses, construction sites, and more, ensuring that every project, regardless of size or complexity, is completed with precision and efficiency."
  },
  {
    "WhyChooseheading": "High-Quality Materials",
    "WhyChoosedescription": "We use only the highest-quality materials for our industrial fabrication projects, ensuring the strength, durability, and reliability of every product we create. From mild steel (MS) to stainless steel and aluminum, we provide materials that are specifically chosen to meet your project's requirements. Our commitment to quality ensures that each fabricated structure, machine, or component performs optimally, even in demanding environments, and meets industry standards for safety and longevity."
  },
  {
    "WhyChooseheading": "Skilled and Experienced Workforce",
    "WhyChoosedescription": "Our team of skilled engineers, fabricators, and technicians has years of experience handling complex industrial fabrication tasks. With their expertise, we are able to deliver top-notch craftsmanship and meticulous attention to detail in every project. Whether it's a custom design or a high-volume production order, our workforce is committed to ensuring the highest level of quality and precision. You can trust our experienced team to handle any fabrication challenge with efficiency and professionalism."
  },
  {
    "WhyChooseheading": "Custom Fabrication Solutions",
    "WhyChoosedescription": "At Anjali Enterprises, we understand that every industrial project is unique. That's why we offer fully customized fabrication solutions tailored to meet your specific needs. Whether it's for a manufacturing plant, warehouse, or construction site, we work closely with you to design and fabricate structures and components that precisely fit your requirements. Our ability to customize every aspect of our fabrication work ensures that your project is delivered exactly as envisioned, meeting all functional and design specifications."
  },
  {
    "WhyChooseheading": "Precision and Accuracy",
    "WhyChoosedescription": "We utilize advanced tools, equipment, and technologies to ensure precise measurements, cuts, and finishes in all our industrial fabrication projects. Our focus on precision guarantees that every fabricated component adheres to high industry standards, ensuring a perfect fit and optimal performance. From the initial design to the final product, we prioritize accuracy at every stage, so your project meets the highest level of quality and functionality."
  },
  {
    "WhyChooseheading": "Cost-Effective Solutions",
    "WhyChoosedescription": "We are dedicated to providing cost-effective industrial fabrication services that don’t compromise on quality. Our efficient processes, along with our expertise in material selection and fabrication techniques, allow us to offer competitive pricing while ensuring that each product is durable and reliable. We help our clients save on material and labor costs, ensuring that they receive a high-quality product at a reasonable price. With Anjali Enterprises, you get the best value for your investment in industrial fabrication work."
  },
  {
    "WhyChooseheading": "Timely Delivery",
    "WhyChoosedescription": "We understand that meeting deadlines is critical in industrial projects. That’s why we work diligently to ensure that every fabrication project is completed on time and delivered as per the agreed schedule. Our team adheres to strict project timelines, and we prioritize efficiency in our workflow, which helps avoid delays in your operations. Whether it's a large-scale or a time-sensitive project, we ensure that your fabrication work is delivered when you need it, helping your business run smoothly."
  },
  {
    "WhyChooseheading": "Versatility Across Industries",
    "WhyChoosedescription": "Our industrial fabrication services are versatile and adaptable, catering to a wide range of industries, including manufacturing, construction, automotive, oil and gas, power, and more. No matter the complexity or scope of your project, Anjali Enterprises has the experience and capability to provide the right fabrication solutions. We work across various sectors, ensuring that each project is tailored to meet the specific needs of the industry, providing safe, functional, and reliable solutions."
  },
  {
    "WhyChooseheading": "Quality Assurance and Safety Standards",
    "WhyChoosedescription": "We follow stringent quality control processes to ensure that every product we fabricate meets the highest standards of performance, safety, and durability. From materials sourcing to final product inspection, we maintain rigorous quality assurance checks to ensure top-notch results. Our industrial fabrication work complies with all relevant industry safety regulations, providing peace of mind to our clients that their projects will be executed with the utmost attention to safety and quality. This commitment to excellence is what sets us apart as a trusted industrial fabrication partner."
  }
]



  }

  const faqData = [
    {
      question: "What types of industrial fabrication services do you offer?",
      answer: "We offer a wide range of industrial fabrication services, including custom metal structures, steel fabrication, welding, machinery components, industrial doors, shades, partitions, and much more. Whatever your industrial needs, we can handle it."
    },
    {
      question: "Do you provide custom fabrication solutions?",
      answer: "Yes, we specialize in providing customized fabrication solutions tailored to the specific requirements of our clients. Our team works closely with you to design and create products that meet your exact specifications."
    },
    {
      question: "What materials do you use for industrial fabrication?",
      answer: "We use a variety of high-quality materials, including mild steel (MS), stainless steel, aluminum, and more. We choose the best material based on the specific needs of the project to ensure durability and strength."
    },
    {
      question: "How do you ensure the quality of your industrial fabrication work?",
      answer: "We follow strict quality control processes throughout every stage of the fabrication process. Our skilled team performs regular inspections to ensure that all fabricated components meet industry standards and client specifications."
    },
    {
      question: "Are your industrial fabrication services affordable?",
      answer: "Yes, we strive to provide cost-effective industrial fabrication services without compromising on quality. We aim to offer competitive pricing to help businesses get the best value for their investment."
    },
    {
      question: "How long does it take to complete an industrial fabrication project?",
      answer: "The time required to complete an industrial fabrication project depends on its complexity and size. We work efficiently to ensure timely delivery, and we provide clear timelines and updates throughout the project."
    },
    {
      question: "Can you handle large-scale industrial fabrication projects?",
      answer: "Yes, we are fully equipped to handle large-scale industrial fabrication projects. Whether it's a big infrastructure project, factory setup, or heavy equipment fabrication, our team has the capacity and expertise to manage large volumes of work."
    },
    {
      question: "Is your fabrication work compliant with industry standards?",
      answer: "Absolutely! Our industrial fabrication work complies with all relevant industry standards and safety regulations, ensuring the highest levels of safety, quality, and performance."
    },
    {
      question: "Do you offer installation services for fabricated products?",
      answer: "Yes, we offer installation services for all our fabricated products. Our experienced team ensures that the fabricated items are installed safely and according to your requirements."
    },
    {
      question: "Why should I choose Anjali Enterprises for my industrial fabrication needs?",
      answer: "Anjali Enterprises stands out for its high-quality craftsmanship, skilled workforce, customized solutions, and timely delivery. We offer affordable and reliable industrial fabrication services for various industries and are committed to meeting your specific needs."
    }
  ];
  
  const testimonials = [
    {
      name: "Mr. Arvind Mehta",
      text: "Anjali Enterprises did an excellent job on our industrial fabrication project. From custom steel structures to machine components, everything was done to perfection. The team was professional, and the project was completed on time. Highly recommend their services!"
    },
    {
      name: "Ms. Rina Shah",
      text: "We’ve worked with Anjali Enterprises on multiple industrial fabrication projects, and they never disappoint. Their attention to detail, quality of work, and customer service are outstanding. They are our go-to fabricator for all our industrial needs."
    }
  ];
  



  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>




<Helmet>
  <title> Industrial Fabrication Services in Pune</title>
  <meta name="description" content="Anjali Enterprises offers all types of industrial fabrication services in Pune, including custom metal fabrication, heavy-duty metal work, steel components, and structural fabrication for industrial units. Call +91 8793220265 for industrial fabrication solutions." />
  <meta name="keywords" content="Industrial Fabrication Services, Custom Industrial Fabrication, Metal Fabrication Pune, Industrial Steel Fabrication, Heavy-Duty Metal Work, Structural Fabrication, Fabrication of Steel Components, Custom Industrial Fabrication Services, MS Fabrication Work for Industrial Units, Precision Metal Fabrication for Industries" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Industrial Fabrication Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers all types of industrial fabrication services in Pune, including custom metal fabrication, heavy-duty metal work, steel components, and structural fabrication for industrial units. Call +91 8793220265 for industrial fabrication solutions." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/industrial-fabrication-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/industrial-fabrication-services" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers all types of industrial fabrication services in Pune, including custom metal fabrication, heavy-duty metal work, steel components, and structural fabrication for industrial units. Call +91 8793220265 for industrial fabrication solutions.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/industrial-fabrication-services",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/industrial-fabrication-service.jpg",
        "priceRange": "₹15000 - ₹100000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/industrial-fabrication-services",
          "priceCurrency": "INR",
          "price": "15000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "35"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravindra M"
            },
            "datePublished": "2024-08-14",
            "reviewBody": "We hired Anjali Enterprises for industrial steel fabrication work at our factory. The team provided a custom solution that met all our needs. Their precision and timely delivery were excellent!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sandeep T"
            },
            "datePublished": "2024-10-02",
            "reviewBody": "Their metal fabrication services were top-notch. We needed heavy-duty steel components, and Anjali Enterprises delivered exactly what we were looking for. Highly professional team!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/industrial-fabrication-services"
        },
        "keywords": "Industrial Fabrication Services, Custom Industrial Fabrication, Metal Fabrication Pune, Industrial Steel Fabrication, Heavy-Duty Metal Work, Structural Fabrication, Fabrication of Steel Components, Custom Industrial Fabrication Services, MS Fabrication Work for Industrial Units, Precision Metal Fabrication for Industries"
      }
    `}
  </script>
</Helmet>

      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/15.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Industrialfabrication;